import React from 'react';
import { observer } from 'mobx-react';

import { UiButton, UiDataBoundary, UiIcon, UiModal, UiModalContent, UiModalTitle } from 'shared/uikit-new';
import { useAsyncEffect, useStore } from 'shared/hooks';
import { notificationsClearQuery, notificationsDeleteQuery, notificationsQuery, notificationsReadQuery } from 'shared/queries';
import { NotificationModel } from 'shared/models';
import { VmNotification } from 'shared/viewmodels';
import { NotificationsModule } from 'shared/modules';

import './styles.scss';
import { COLORS } from 'shared/constants';

export const LayoutNotifications = observer(() => {
    const store = useStore(() => ({
        isOpened: false,
        isSuccess: true,
        isLoading: true,
        notifications: [] as NotificationModel[],
        filter: 'unread',
    }));

    useAsyncEffect(async () => {
        if (!store.isOpened) {
            return;
        }

        store.set('isSuccess', true);
        store.set('isLoading', true);
        const response = await notificationsQuery({
            page: 1,
        });
        if (response.isSuccess && response.data) {
            store.set(
                'notifications',
                response.data.items.map(item => new NotificationModel(item))
            );
        } else {
            store.set('isSuccess', false);
        }
        store.set('isLoading', false);
    }, [store, store.isOpened]);

    const handleClose = () => {
        store.set('isOpened', false);
    };

    const handleDelete = async (notification: NotificationModel) => {
        store.set(
            'notifications',
            store.notifications.filter(item => item.id !== notification.id)
        );
        await notificationsDeleteQuery({ id: notification.id });
        NotificationsModule.fetchUnreadCount();
    };

    const handleHover = async (notification: NotificationModel) => {
        if (!!notification.readAt) {
            return;
        }
        await notificationsReadQuery({ id: [notification.id] });
        notification.update({
            readAt: 'now',
        });
        NotificationsModule.fetchUnreadCount();
    };

    const handleClear = async () => {
        store.set('notifications', []);
        await notificationsClearQuery();
        NotificationsModule.fetchUnreadCount();
    };

    return (
        <>
            <div className='layout-notifications--desktop layout-header-icon'>
                <div className='layout-header-icon__inner' onClick={() => store.set('isOpened', true)}>
                    <UiIcon.Bell size={24} />
                    {!!NotificationsModule.unreadCount && <div className='layout-header-icon__counter'>{NotificationsModule.unreadCount}</div>}
                </div>
            </div>
            <div onClick={() => store.set('isOpened', !store.isOpened)} className='layout-menu-mobile-item layout-notifications--mobile'>
                <UiIcon.Bell size={24} />
                {!!NotificationsModule.unreadCount && <div className='layout-menu-mobile-item__counter'>{NotificationsModule.unreadCount}</div>}
            </div>
            <UiModal isAside isOpened={store.isOpened} onClose={() => store.set('isOpened', false)}>
                <UiModalTitle
                    aside={() =>
                        store.notifications.length > 0 && (
                            <UiButton onClick={handleClear} template={'link'} style={{
                                color: [COLORS._9EA2AA, COLORS._474A50],
                                backgroundColor: [COLORS.TRANSPARENT, COLORS.TRANSPARENT],
                                textDecoration: 'none'
                            }}>
                                <UiIcon.Trash2 size={16} />
                                <span>Очистить все</span>
                            </UiButton>
                        )
                    }
                >
                    <div className='layout-notifications-modal__icon'>
                        <UiIcon.Bell size={24} />
                    </div>
                    <span>Уведомления</span>
                </UiModalTitle>
                <UiModalContent>
                    <UiDataBoundary isLoading={store.isLoading}>
                        {store.notifications.length > 0 && (
                            <div className='layout-notifications__items'>
                                {store.notifications.map(notification => (
                                    <VmNotification key={notification.id} notification={notification} onClose={handleClose} onDelete={handleDelete} onHover={handleHover} />
                                ))}
                            </div>
                        )}
                        {store.notifications.length === 0 && (
                            <div className='layout-notifications__empty'>
                                <img src={require('./assets/empty.png')} alt='' />
                                <span>Список уведомлений пуст</span>
                            </div>
                        )}
                    </UiDataBoundary>
                </UiModalContent>
            </UiModal>
        </>
    );
});
